<style>
  #MyListMenu li {
    list-style: none;
  }

  .Lvl2 {
    margin: 10px 20px;
  }
</style>

<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ویرایش اطلاعات کاربر '{{FullName}}'</h5>
    <form [formGroup]="EditUser" (submit)="SubmitEditUser()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">رمز عبور (در صورت تعیین رمز جدید) </label>
          <input formControlName="Password" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Password().valid && get_Form_Password().touched"
            class="form-text text-muted MyErrorRedColor">رمز عبور را وارد نمائید. (حداقل 6 کاراکتر)</small>
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نوع کاربر </label>
          <select formControlName="Type" class="custom-select">
            <option value="0">انتخاب کنید</option>
            <option value="1">کاربر ارشد</option>
            <option value="2">کاربر عادی</option>
          </select>
        </div>

        <div class="form-group col-md-4" *ngIf="get_Form_Type().value!='1'">
          <label for="exampleInputEmail1"> کارشناسان کالیبراسیون </label>
          <select formControlName="ExpertCalibration" class="custom-select">
            <option value="0">اطلاعات فردی</option>
            <option value="1">همه اطلاعات</option>
          </select>
        </div>
        <div class="form-group col-md-4" *ngIf="get_Form_Type().value=='1'">
          <label for="exampleInputEmail1"> کارشناسان کالیبراسیون </label>
          <p>همه اطلاعات</p>
        </div>
      </div>

 

      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!EditUser.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button routerLink="/User" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>
